import React, { Component } from 'react';
import './Switch.sass';

class Switch extends Component {
    constructor(props) {
        super(props);
        this.state = { activeSide: true };

    }

    setActiveSide = () => {
        this.setState({ activeSide: !this.state.activeSide });

        setTimeout(() => this.props.onSelectActive(this.state.activeSide), 10);

    }

    render() {

        var html = <label className="switch">
            <input type="checkbox" checked={this.state.activeSide} />
            <span className="slider" onClick={() => this.setActiveSide()} />
        </label>;

        return html;
    }
}

export default Switch;
